import { Button } from "components/Common/Button";
import { withReadOnlyWrapper } from "components/Common/ReadOnlyWrapper";

/** @deprecated Use Button from @adasupport/byron instead */
export const ControlledAccessButton = withReadOnlyWrapper(Button);
